export default __webpack_public_path__ + "static/media/factory_future_icon.568f9c40.svg";